<template>
    <div class="list-scroll-container">
        <div class="list-container"
             :style="`--padding: ${type === 'flat' ? '0': '16px'}`">
            <component :is="isRouterLink(item.link) ? 'router-link' : 'a'"
                       :class="{
                            'list-item': true,
                            'button': true,
                            'flat-button': type === 'flat'
                       }"
                       v-for="(item, index) in data"
                       :key="index"
                       @click="clicked"
                       @click.native="isRouterLink(item.link) ? clicked : ''"
                       :to="item.link"
                       :href="item.link">
                <img v-if="item.icon && type !== 'flat'"
                     :alt="item.icon"
                     :src="require(`@/assets/${item.icon}-24px.svg`)">
                {{item.name}}
            </component>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ListView",
		props: {
			data: {
				type: Array,
				required: true
			},
			callback: {
				type: Function,
				required: false
			},
			type: {
				type: String,
				required: true
			}
		},
		methods: {
			clicked() {
				if (this.callback) {
					this.callback();
				}
			},
			isRouterLink(link) {
				return link.startsWith('/') && !link.startsWith('/docs')
			}
		}
	}
</script>

<style scoped lang="scss">

    .list-scroll-container {
        overflow-y: scroll;
    }

    .list-container {
        display: flex;
        flex-flow: column nowrap;
        padding: 10px;
        box-sizing: border-box;
        width: 100%;
    }

    img {
        vertical-align: middle;
    }

    .list-item {
        margin: var(--padding) 2px 2px 2px;
        padding: var(--padding);
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
</style>